module.exports = __webpack_public_path__ + "img/vip3.fb64ba95.jpg";